import type { FC } from 'react';

import { ButtonBase } from '@mui/material';
import { QuestionIcon, RocketIcon } from '@truvhq/ui';

import { useChecklistProgress } from 'features/onboarding/lib/useOnboardingChecklist';
import { useOnboardingDialogStore } from 'features/onboarding/lib/useOnboardingDialogStore';

const DEFAULT_LABEL = 'Ask Truv AI';

// Floating launcher for the assistant, in the bottom-right corner. Below the dialog's z-index so it
// tucks behind the panel once opened.
export const AssistantLauncherButton: FC = () => {
  const open = useOnboardingDialogStore((state) => state.open);
  // While setup is unfinished the launcher says how far along it is and leads with the rocket; it
  // only offers the assistant in the abstract once there is nothing left to point at.
  const progress = useChecklistProgress();
  const Icon = progress ? RocketIcon : QuestionIcon;

  return (
    <ButtonBase
      onClick={open}
      sx={{
        position: 'fixed',
        right: 24,
        bottom: 22,
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        maxWidth: 'calc(100vw - 3rem)',
        padding: '11px 19px',
        borderRadius: 9999,
        border: '1px solid',
        borderColor: 'grey.300',
        backgroundColor: 'common.white',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.12)',
        color: 'text.primary',
        font: '500 14px/20px system-ui',
        '&:hover': { borderColor: 'primary.main', backgroundColor: 'common.white' },
      }}
    >
      <Icon width={18} height={18} aria-hidden />
      <span className="truncate">
        {progress ? `Setup: step ${progress.position} of ${progress.total}` : DEFAULT_LABEL}
      </span>
    </ButtonBase>
  );
};
